import { gql } from '@lcs/shared/api';

export const runPhoneQueues = gql`
   query RunPhoneQueues($params: ExecuteTilePostModelPhoneQueuesTileReportParametersInput!) {
      runPhoneQueuesTile(params: $params) {
         data {
            queues {
               queueExtensionId
               queueName
               queueNumber
               averageHoldLast30Minutes
               averageHoldToday
               loggedInAgents
               callsWaiting
               callsAbandoned
               oldestCall
               oldestCallWaiting
            }
         }
         dashboardTileId
      }
   }
`;
